import React, { useState } from "react";
import { CloudOff, AlertTriangle, RotateCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { retryUpload } from "@/lib/offlineSync";

// Badge for queued photos: amber "Noch nicht übertragen" or red "fehlgeschlagen" with retry.
export default function UploadStateBadge({ f, small }) {
  const [busy, setBusy] = useState(false);
  if (!f.__pending) return null;
  const txt = small ? "text-[9px] py-0.5 px-1" : "text-[10px] py-1 px-2";
  if (!f.__failed) {
    return (
      <span data-testid={`photo-pending-${f.id}`} className={`absolute top-1 left-1 right-1 inline-flex items-center justify-center gap-1 text-center leading-tight rounded-md bg-amber-500 text-white font-medium shadow ${txt}`}>
        <CloudOff className="h-3 w-3 shrink-0" />Noch nicht übertragen
      </span>
    );
  }
  const retry = async (e) => {
    e.stopPropagation();
    if (!navigator.onLine) return toast.error("Erneut senden geht nur mit Internetverbindung");
    setBusy(true);
    await retryUpload(f.__opId).catch(() => {});
    setBusy(false);
  };
  return (
    <div className="absolute inset-x-1 top-1 flex flex-col gap-1" title={f.__error || ""}>
      <span data-testid={`photo-failed-${f.id}`} className={`inline-flex items-center justify-center gap-1 text-center leading-tight rounded-md bg-red-600 text-white font-medium shadow ${txt}`}>
        <AlertTriangle className={`h-3 w-3 shrink-0 ${small ? "hidden" : ""}`} />{small ? "Fehlgeschlagen" : "Übertragung fehlgeschlagen"}
      </span>
      <button type="button" onClick={retry} disabled={busy} data-testid={`photo-retry-${f.id}`}
        className={`inline-flex items-center justify-center gap-1 rounded-md bg-white text-red-700 font-semibold shadow hover:bg-red-50 transition-colors disabled:opacity-60 ${txt}`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <RotateCw className="h-3 w-3" />}{small ? "Erneut" : "Erneut senden"}
      </button>
    </div>
  );
}
